<template>
<div>
    <business-partner-address-form :getBusinessPartnerAddressList="getBusinessPartnerAddressList" ref="businessPartnerAddressFormModal"></business-partner-address-form>
    <b-row>
        <b-col class="col-12">
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('businessPartnerAddress.add') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="businessPartnerAddressTable" ref="businessPartnerAddressTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
              }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'addressType'" class="text-nowrap">
                {{ $t('businessPartnerAddress.address_type') }}
            </span>
            <span v-else-if="props.column.field === 'address'" class="text-nowrap">
                {{ $t('businessPartnerAddress.address') }}
            </span>
            <span v-else-if="props.column.field === 'zipCode'" class="text-nowrap">
                {{ $t('businessPartnerAddress.zip_code') }}
            </span>
            <span v-else-if="props.column.field === 'country'" class="text-nowrap">
                {{ $t('businessPartnerAddress.country') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Address -->
            <span v-if="props.column.field === 'address'">
                <span class="wh-clamp-2" v-b-tooltip.hover="{ title: props.row.address, customClass: 'wh-tooltip' }">{{ props.row.address }}</span>
            </span>
            <!-- Column: Process -->
            <span v-else-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        businessPartnerId: Number,
    },
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('businessPartnerAddress.address_type'),
                    field: `addressType`,
                },
                {
                    label: this.$t('businessPartnerAddress.address'),
                    field: `address`,
                },
                {
                    label: this.$t('businessPartnerAddress.zip_code'),
                    field: `zipCode`,
                },
                {
                    label: this.$t('businessPartnerAddress.country'),
                    field: `country`,
                },
                {
                    label: '',
                    field: 'process',
                    width: '10em',
                    sortable: false
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getBusinessPartnerAddressList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'BusinessPartnerAddress'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getBusinessPartnerAddressList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getBusinessPartnerAddressList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.businessPartnerAddressFormModal.showInfo(id, this.businessPartnerId)
        },
        getBusinessPartnerAddressList() {
            this.rows = []
            const data = {
                id: this.businessPartnerId
            }
            const controller = {
                name: 'BusinessPartnerAddress',
                actionName: 'GetBusinessPartnerAddressListByBusinessPartnerId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.businessPartnerAddressList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
